module.exports = __webpack_public_path__ + "static/ausenFrontLogo-e725d7ec6f5909702254f909f8d8c854.jpg";